import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import RichTextEditor from 'Components/UI/RichTextEditor';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import DetailItems from './Layout/DetailItems';

const overrideFD = { ordinal: overrideReadOnly.ordinal + 1 };

export default buildFacetDesignOverride()
  .overrideAll({
    _customProps: {
      fullWidth: true,
    },
  }, overrideReadOnly)
  .nameOverride('startDate', {
    hidden: false, // This should not need to be here but is needed because all readonly fields are hidden in a previous override.
  }, overrideReadOnly)
  .nameOverride(['moduleName'], {
    hidden: true,
  }, overrideReadOnly)
  .nameOverride('detailItems', {
    _component: () => DetailItems,
    _spreadPropNames: ['resource', 'attrName'],
  }, overrideReadOnly)
  .override({ hint: 'richtext', readonly: true }, {
    _component: () => Richtext,
  }, overrideReadOnly)
  .override({ hint: 'richtext', readonly: false }, {
    _component: () => RichTextEditor,
  }, overrideFD);
